import { ThemeProvider as BaseThemeProvider, DefaultTheme } from "styled-components";

const theme: DefaultTheme = {
    colors: {
        primary: '#1890ff',
        primaryMedium: '#8bc7ff',
        primaryLight: '#e6f4ff',
        danger: '#ff0000',
        dangerLight: '#ff4d4f',
        white: '#ffffff',
        neutral: '#d9d9d9',
        neutralLight: '#f5f5f5',
        neutralHover: '#e0e0e0',
        default: 'black',
    }
}

export const ThemeProvider = ({ children }: React.PropsWithChildren) => {
    return <BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>;
}